export * from './points-extract.page'
export * from './points-extract.reducer'
